import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ModalGenericComponent } from '../../../shared/components/modal-generic/modal-generic.component';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { GtmService } from '../../../shared/services/gtm/gtm.service';
import { MIN_STATUS } from '../../../shared/utils/constants';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { CommentModel } from '../../models/comment.model';
import { FileUploadModel } from '../../models/file-upload.model';
import { WallService } from '../../services/wall/wall.service';

@Component({
  selector: 'app-wall-container',
  templateUrl: './wall-container.component.html',
  styleUrls: ['./wall-container.component.scss'],
  standalone: false,
})
export class WallContainerComponent implements OnInit, OnDestroy {
  maxComment = 1500;

  commentInput: UntypedFormControl;
  listComment: CommentModel[] = [];
  completeScroll: boolean = false;
  commentsInterval: any;
  subscriptions = new Subscription();
  public error: Object;
  public status: number = 0;
  public minStatus: number = MIN_STATUS.attachDocumentation;

  @Input() markAsRead: boolean = true;

  public file: FileUploadModel;
  public fileError: {
    hasError: string;
    msgError: string;
  };

  constructor(
    private _wallService: WallService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private gtm: GtmService,
  ) {
    this.commentInput = new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(this.maxComment),
    ]);
  }

  ngOnInit() {
    this._wallService.subscribeInterval();
    if (this.markAsRead) {
      this._wallService.markAsRead = true;
      this.authService.updateStatus(true);
      this.gtm.sendVarGTM({ pageType: 'tus_mensajes' });
    }
    this.getComments();
    this.getStatus();
    this.subscriptions.add(
      this._wallService
        .getCopleteScroll()
        .subscribe((completeScroll) => (this.completeScroll = completeScroll)),
    );
    this.subscriptions.add(
      this._wallService.getErrorServer().subscribe((error) => {
        this.error = error;
      }),
    );
  }

  getComments(size: number = 10) {
    this.subscriptions.add(
      this._wallService.getListComments().subscribe((data) => {
        this.listComment = data;
      }),
    );
  }

  getMoreComments() {
    this.completeScroll = true;
    this._wallService.getMoreComments();
  }

  private getStatus() {
    this.authService.getStatus().subscribe((response) => {
      this.status = parseInt(response, 10);
    });
  }

  sendComment() {
    if (this.fileError) {
      this.confirmDeleteUser();
      return;
    }
    if (this.commentInput.valid || this.file) {
      if (this.file) {
        const formData = new FormData();
        formData.append('documentDesc', this.file.documentDesc);
        formData.append('category', this.file.category);
        formData.append('file', this.file.file);
        formData.append('documentType', this.file.type);
        let commentAux = this.commentInput.value ? this.commentInput.value + '\n\n' : '';
        commentAux =
          commentAux +
          `${this.translate.instant('wall_container_attached_file')}${this.file.name} - ${this.file.size.toFixed(1)} MB`;
        this.subscriptions.add(
          this._wallService
            .saveCommentandFile({ text: commentAux, createdBy: 'Cliente' }, formData)
            .subscribe((comment) => {
              this.listComment.unshift(comment);
              this.commentInput.setValue('');
              this.file = null;
            }),
        );
      } else {
        this.subscriptions.add(
          this._wallService
            .setComment({ text: this.commentInput.value, createdBy: 'Cliente' })
            .subscribe((comment) => {
              this.listComment.unshift(comment);
              this.commentInput.setValue('');
            }),
        );
      }
    }
  }

  setFile(fileData) {
    this.fileError = null;
    this.file = fileData;
    this.file.category = 'MTG_C02';
    this.file.type = 'DOC_20';
    this.file.documentDesc = this.translate.instant(
      'wall_content_file_attached_from_messages',
    );
  }

  setErrorFile(fileError) {
    this.file = null;
    this.fileError = fileError;
  }

  confirmDeleteUser() {
    const titleModal = this.translate.instant('wall_container_modal_title');
    const message = 'wall_container_modal_message';

    const data = {
      message: message,
      txtButtonCancel: 'btn_cancel',
    };
    const options: Object = {
      header: titleModal,
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: () => {
        this.fileError = undefined;
        this.sendComment();
      },
      reject: () => {},
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this._wallService.unsubscribeInterval();
  }
}
